import { Box, Button } from '@mui/material';
import Link from 'next/link';
import { useTranslation } from 'react-i18next';

export function AndroidFloatWindowLink() {
  const { t } = useTranslation('homepage/components/android-float/window/content');
  return (
    <Box sx={{mt:1, mb:1}}>
      <Button component={Link} href="/android-float-window" variant="contained" color="primary" data-testid="AndroidFloatWindowLink__linkButton__01JG2B0082" data-test-comment="浮窗管理链接按钮，点击后导航到浮窗管理页面">
         {t('AndroidFloatWindowLink.name')}
      </Button>
    </Box>
  );
}
